module.exports = __webpack_public_path__ + "img/map-napoli.864981ef.svg";